/**
 * @class
 */
import Base from '@netx/core/lib/netx-multiView';
import Template from '../templates/appBodyView.html';

class AppBodyView extends Base {
	/** @override */
	constructor(opts = {}) {
		opts.additionalViewClasses = opts.additionalViewClasses || 'body-view';
		opts.childView = {
			viewClass(model) {
				return model.get('viewClass');
			},
			...opts.childView,
		};
		opts.id = opts.id || 'body-view';
		opts.template = opts.template || Template;
		super(opts);
	}

	/**
	 * @static
	 * @type {string}
	 */
	static get __name__() {
		return 'AppBodyView';
	}
}

export default AppBodyView;
